export const pageTr = {
  fr: {
    nav: { labs: "Laboratoires", formation: "Formation", treatments: "Traitements", synthetics: "Synthétiques", journal: "Journal" },
    back: "← Retour",
    labs: {
      title: "Les principaux laboratoires gemmologiques dans le monde",
      subtitle: "Adresses, téléphones et informations essentielles pour faire certifier vos pierres précieuses en toute confiance.",
      publicBadge: "Informations accessibles à tous",
      trustBadge: "Des laboratoires reconnus dans le monde entier",
      why: "Pourquoi faire certifier votre pierre ?",
      whyItems: [
        { t: "Authenticité", d: "Confirmation de la nature de la pierre" },
        { t: "Origine", d: "Détermination de la provenance géographique" },
        { t: "Traitements", d: "Identification des traitements et améliorations éventuelles" },
        { t: "Valeur", d: "Rapport officiel reconnu internationalement" },
      ],
      speciality: "Spécialité principale",
      specialityItems: [
        { t: "Diamants", d: "et pierres de couleur" },
        { t: "Pierres de couleur", d: "(rubis, saphirs, émeraudes...)" },
        { t: "Origine géographique", d: "et traitements avancés" },
        { t: "Recherche scientifique", d: "et innovation" },
      ],
      others: "Autres laboratoires de référence",
      disclaimer: "Ces laboratoires sont reconnus internationalement pour leur expertise, leur indépendance et la qualité de leurs rapports. Les coordonnées peuvent être sujettes à modification.",
      ctaSubscribe: "Accédez aux tarifications par pays et par poids (carat) après abonnement à Gem Price",
    },
    formation: {
      title: "Formation naturelle des pierres précieuses",
      titleEn: "Natural Formation of Precious Gemstones",
      tagline: "La nature crée, nous révélons.",
      section: "Formation naturelle",
      chem: "Composition chimique",
      crystal: "Système cristallin",
      keyElement: "Élément clé de couleur",
      color: "Couleur",
      steps: ["Origine", "Environnement géologique", "Processus de formation", "Érosion & dépôts alluvionnaires"],
      footer1: "Ces informations décrivent le processus général de formation naturelle. Chaque gisement possède ses particularités géologiques.",
      footer2: "Les couleurs peuvent varier selon la concentration des éléments traces et les conditions de formation.",
      footer3: "Pierres naturelles uniques, formées par des millions d'années de processus géologiques extraordinaires.",
    },
    treatments: {
      title: "Les traitements des pierres précieuses",
      subtitle: "Comprendre les principaux traitements utilisés pour améliorer l'apparence des pierres.",
      main: "Principaux traitements",
      remember: "À retenir",
      rememberItems: [
        "Les traitements sont identifiés et notés sur les certificats gemmologiques.",
        "Les traitements n'ont pas le même impact sur la valeur et la durabilité de la pierre.",
        "La transparence et l'information sont essentielles pour acheter en toute confiance.",
        "Exigez toujours un certificat d'un laboratoire reconnu (GIA, IGI, Gübelin, SSEF...).",
      ],
      subscribeCta: "Pour connaître les tarifications détaillées par pays de provenance et par poids (carat) abonnez-vous à Gem Price et accédez à toutes les données complètes.",
    },
    synthetics: {
      title: "Les méthodes de fabrication des pierres synthétiques",
      subtitle: "Comprendre comment les pierres synthétiques sont créées en laboratoire.",
      main: "Principales méthodes de fabrication",
      identify: "Comment les identifier ?",
      remember: [
        { t: "Analyses en laboratoire", d: "Indispensables pour distinguer les pierres naturelles des synthétiques." },
        { t: "Certificat recommandé", d: "Exigez toujours un certificat (IGI, GIA, Gübelin, SSEF...)." },
        { t: "Même apparence", d: "Les synthétiques peuvent être visuellement identiques aux naturels." },
        { t: "Valeur différente", d: "Les pierres synthétiques ont une valeur nettement inférieure aux naturelles." },
      ],
      subscribeCta: "Accédez à l'ensemble des informations complètes et aux tarifications détaillées après abonnement à Gem Price.",
    },
    journal: {
      title: "Le Journal Mensuel",
      subtitle: "L'actualité des pierres précieuses et de la gemmologie",
      newMonthly: "Nouveau numéro chaque mois",
      intro: "Restez informé, inspirez-vous, anticipez.",
      body: "Chaque mois, Gem Price vous propose un tour d'horizon complet du monde des pierres précieuses : découvertes, recherches, analyses, événements et tendances du marché.",
      summary: "Au sommaire de chaque édition",
      articlesTitle: "Articles récents",
      eventsTitle: "Salons & événements",
      empty: "Aucun élément pour le moment.",
      adminOpen: "Espace admin",
      adminTitle: "Espace administrateur",
      adminPwd: "Mot de passe admin",
      adminLogin: "Se connecter",
      addArticle: "Ajouter un article",
      addEvent: "Ajouter un événement",
      formArticle: { title: "Titre", category: "Catégorie", excerpt: "Résumé", body: "Contenu", image: "URL image", author: "Auteur", submit: "Publier" },
      formEvent: { name: "Nom du salon", city: "Ville", country: "Pays", start: "Date début", end: "Date fin", url: "Site web", submit: "Publier" },
      categories: { discovery: "Découverte de nouvelles mines", scientific: "Recherches et analyses scientifiques", newstones: "Nouvelles pierres", market: "Tendances du marché", show: "Salons et événements", focus: "Focus collection et créateurs" },
      lockedTitle: "Accédez à l'intégralité du journal mensuel",
      lockedBody: "Tous les numéros, tous les articles et toutes les analyses sont réservés aux abonnés de Gem Price.",
      lockedCta: "Voir les offres d'abonnement",
    },
  },
  en: {
    nav: { labs: "Laboratories", formation: "Formation", treatments: "Treatments", synthetics: "Synthetics", journal: "Journal" },
    back: "← Back",
    labs: {
      title: "The main gemmological laboratories in the world",
      subtitle: "Addresses, phone numbers and essential information to have your precious stones certified with confidence.",
      publicBadge: "Information accessible to all",
      trustBadge: "Internationally recognized laboratories",
      why: "Why get your stone certified?",
      whyItems: [
        { t: "Authenticity", d: "Confirmation of the nature of the stone" },
        { t: "Origin", d: "Determination of geographical origin" },
        { t: "Treatments", d: "Identification of treatments and enhancements" },
        { t: "Value", d: "Internationally recognized official report" },
      ],
      speciality: "Main specialty",
      specialityItems: [
        { t: "Diamonds", d: "and colored stones" },
        { t: "Colored stones", d: "(rubies, sapphires, emeralds...)" },
        { t: "Geographical origin", d: "and advanced treatments" },
        { t: "Scientific research", d: "and innovation" },
      ],
      others: "Other reference laboratories",
      disclaimer: "These laboratories are internationally recognized for their expertise, independence and quality of reports. Contact details are subject to change.",
      ctaSubscribe: "Access pricing by country and weight (carat) after subscribing to Gem Price",
    },
    formation: {
      title: "Natural Formation of Precious Gemstones",
      titleEn: "Natural Formation of Precious Gemstones",
      tagline: "Nature creates, we reveal.",
      section: "Natural formation",
      chem: "Chemical composition",
      crystal: "Crystal system",
      keyElement: "Key color element",
      color: "Color",
      steps: ["Origin", "Geological environment", "Formation process", "Erosion & alluvial deposits"],
      footer1: "This information describes the general process of natural formation. Each deposit has its own geological particularities.",
      footer2: "Colors can vary depending on the concentration of trace elements and formation conditions.",
      footer3: "Unique natural stones, formed over millions of years of extraordinary geological processes.",
    },
    treatments: {
      title: "Treatments of precious gemstones",
      subtitle: "Understand the main treatments used to enhance the appearance of stones.",
      main: "Main treatments",
      remember: "Key points",
      rememberItems: [
        "Treatments are identified and noted on gemmological certificates.",
        "Treatments do not have the same impact on the value and durability of the stone.",
        "Transparency and information are essential to buy with confidence.",
        "Always request a certificate from a recognized laboratory (GIA, IGI, Gübelin, SSEF...).",
      ],
      subscribeCta: "For detailed pricing by country of origin and by weight (carat), subscribe to Gem Price and access all complete data.",
    },
    synthetics: {
      title: "Manufacturing methods of synthetic stones",
      subtitle: "Understand how synthetic stones are created in the laboratory.",
      main: "Main manufacturing methods",
      identify: "How to identify them?",
      remember: [
        { t: "Laboratory analysis", d: "Essential to distinguish natural stones from synthetics." },
        { t: "Certificate recommended", d: "Always request a certificate (IGI, GIA, Gübelin, SSEF...)." },
        { t: "Same appearance", d: "Synthetics can be visually identical to naturals." },
        { t: "Different value", d: "Synthetic stones have a much lower value than naturals." },
      ],
      subscribeCta: "Access all complete information and detailed pricing after subscribing to Gem Price.",
    },
    journal: {
      title: "Monthly Journal",
      subtitle: "News on precious stones and gemmology",
      newMonthly: "New issue every month",
      intro: "Stay informed, get inspired, anticipate.",
      body: "Every month, Gem Price offers you a complete overview of the world of precious stones: discoveries, research, analyses, events and market trends.",
      summary: "In each edition",
      articlesTitle: "Recent articles",
      eventsTitle: "Shows & events",
      empty: "Nothing yet.",
      adminOpen: "Admin panel",
      adminTitle: "Administrator panel",
      adminPwd: "Admin password",
      adminLogin: "Login",
      addArticle: "Add an article",
      addEvent: "Add an event",
      formArticle: { title: "Title", category: "Category", excerpt: "Summary", body: "Content", image: "Image URL", author: "Author", submit: "Publish" },
      formEvent: { name: "Show name", city: "City", country: "Country", start: "Start date", end: "End date", url: "Website", submit: "Publish" },
      categories: { discovery: "New mines discovery", scientific: "Scientific research", newstones: "New stones", market: "Market trends", show: "Shows & events", focus: "Collections & designers" },
      lockedTitle: "Access the full monthly journal",
      lockedBody: "All issues, articles and analyses are reserved for Gem Price subscribers.",
      lockedCta: "See subscription plans",
    },
  },
};
